import { Injectable } from '@angular/core';
import {GeneralServicesImplService} from '../../../services/general-services-impl.service';
import {HttpClient} from '@angular/common/http';
import * as servers from '../../../services/api/servers';
import {urls} from '../../../services/api/urls';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ProjectConstants} from '../../project-constants';
import {ArchitectureStructureSettingModel} from "../../../models/ArchitectureStructureSettingModel";

@Injectable({
  providedIn: 'root'
})

export class Sl2AnagrafService extends GeneralServicesImplService {

  constructor(http: HttpClient) {
    super(http);
  }

  // baseUrl: string = servers.apiUrl + urls.cobidbService + urls.layer;
  baseUrl: string = servers.apiUrl + urls.sl2;

  getPage(filters: any, payload?: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.PAGE;
    const body =  payload ? JSON.stringify(payload) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json', params: filters})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getListInArchitectureStructure(filter: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.LIST_IN_ARCHITECTURE_STRUCTURE;
    const body =  filter;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  softDelete(id: number): Observable<any> {
    const url = this.baseUrl  + this.LINKS.SOFT_DELETE + id;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.delete(url, {headers: header, responseType: 'json'})
      .pipe(
        map (data => data)
      );
  }
}
